import styled from "styled-components";

export const Container = styled.div`
  .mHeader {
    .MuiTypography-h6 {
      display: flex;
      justify-content: space-between;
      .content {
        .title {
          font-size: 1.2rem;
          font-weight: 500;
        }
        .subtitle {
          font-size: 0.8rem;
          font-weight: 300;
        }
      }
    }
  }

  .mContent {
    min-height: 400px;

    .MuiTabs-indicator {
      background-color: #002951;
    }
  }

  .mFooter {
    padding: 10px 24px;
  }
`;
